import axios from 'axios'
import {SearchResponse} from './_models'

const API_URL = process.env.REACT_APP_THEME_API_URL || process.env.REACT_APP_API_URL

/**
 * GET /api/search — hasil sudah difilter server sesuai role allowedMenus & client scope.
 */
export const globalSearch = async (
  q: string,
  types?: string,
  limit = 5,
  signal?: AbortSignal
): Promise<SearchResponse> => {
  const params: Record<string, string | number> = {q, limit}
  if (types && types !== 'All') params.types = types
  const res: any = await axios.get(`${API_URL}/search`, {params, signal})
  const data = res?.data !== undefined ? res.data : res
  return {
    query: data?.query ?? q,
    tookMs: data?.tookMs ?? 0,
    groups: Array.isArray(data?.groups) ? data.groups : [],
    allowedCategories: Array.isArray(data?.allowedCategories) ? data.allowedCategories : [],
  }
}

/**
 * GET /api/search/categories — membaca kategori yang diizinkan untuk user ini langsung dari backend/DB.
 */
export const getSearchCategories = async (signal?: AbortSignal): Promise<string[]> => {
  const res: any = await axios.get(`${API_URL}/search/categories`, {signal})
  const data = res?.data !== undefined ? res.data : res
  return Array.isArray(data) ? data : []
}
